module.exports = __webpack_public_path__ + "Server-Disabled.TentaclePassive.5f3a3601f7884395810add3be4d7cbb8.hashedasset.svg";